const divModalFilterExpiredServices = {
  cancel: 'CANCELAR',
  ok: 'APLICAR',
  mandatory: 'Mostrar Serviços Obrigatórios',
  nonMandatory: 'Mostrar Serviços Opcionais',
};

export default divModalFilterExpiredServices;
